import { BsTrash } from "react-icons/bs";

const TrashIcon = (props) => {
    return <BsTrash className={props.className} />
} 

export default TrashIcon;